var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPrendoByMgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 45,
    viewBox: "0 0 692 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2566_7310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.114 59.6653C320.548 59.9697 316.438 60.8829 312.785 62.4811C308.219 64.3837 304.49 67.2756 301.826 71.0808V64.0793C301.826 62.2528 300.304 60.7307 298.478 60.7307H283.486C281.659 60.7307 280.137 62.2528 280.137 64.0793V135.54C280.137 137.367 281.659 138.889 283.486 138.889H299.467C301.294 138.889 302.816 137.367 302.816 135.54V101.979C302.816 94.749 304.642 89.2695 308.371 85.6166C312.024 81.9636 317.123 80.1371 323.592 80.1371C323.973 80.1371 324.505 80.1371 325.114 80.2132C327.017 80.2893 328.615 78.7673 328.615 76.8647V63.0138C328.691 61.0351 327.017 59.5131 325.114 59.6653Z",
    fill: "url(#paint0_linear_2566_7310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.075 64.4598C386.91 61.1873 379.985 59.513 372.298 59.513C364.46 59.513 357.382 61.2634 350.989 64.6881C344.673 68.1127 339.65 72.9072 335.997 79.0716C332.344 85.236 330.517 92.1614 330.517 99.7718C330.517 107.534 332.344 114.46 336.073 120.548C339.726 126.636 344.977 131.431 351.75 134.855C358.524 138.28 366.362 140.031 375.114 140.031C388.128 140.031 398.326 136.454 405.556 129.3C406.621 128.311 406.621 126.636 405.632 125.571L397.032 116.286C396.043 115.221 394.444 115.145 393.379 115.982C391.172 117.732 388.889 119.102 386.454 120.091C383.333 121.309 379.68 121.918 375.647 121.918C369.711 121.918 364.764 120.548 360.807 117.732C356.849 114.916 354.338 111.111 353.272 106.241H410.426C411.568 106.241 412.481 105.403 412.557 104.262C412.709 101.75 412.861 100.381 412.861 100.152C412.861 92.0092 411.111 84.8555 407.534 78.6911C404.186 72.4506 399.315 67.7322 393.075 64.4598ZM353.12 92.9225C353.881 87.8996 356.012 83.9423 359.513 80.9742C363.014 78.0823 367.275 76.6363 372.45 76.6363C377.473 76.6363 381.735 78.0823 385.236 81.0503C388.737 84.0184 390.868 87.9757 391.629 92.9225H353.12V92.9225Z",
    fill: "url(#paint1_linear_2566_7310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.225 78.9955C682.572 72.9072 677.473 68.1127 671.005 64.6881C664.536 61.2634 657.154 59.513 648.935 59.513C640.715 59.513 633.333 61.2634 626.788 64.6881C620.243 68.1127 615.145 72.9072 611.492 78.9955C607.839 85.0838 605.936 92.0092 605.936 99.7718C605.936 107.534 607.763 114.46 611.492 120.548C615.145 126.636 620.243 131.431 626.788 134.855C633.333 138.28 640.715 140.031 648.935 140.031C657.154 140.031 664.536 138.28 671.005 134.855C677.473 131.431 682.572 126.636 686.225 120.548C689.878 114.46 691.781 107.534 691.781 99.7718C691.705 92.0092 689.878 85.0838 686.225 78.9955ZM663.166 115.525C659.437 119.483 654.642 121.385 648.858 121.385C643.075 121.385 638.28 119.406 634.475 115.525C630.67 111.568 628.843 106.317 628.843 99.7718C628.843 93.1508 630.746 87.8996 634.475 84.0184C638.28 80.061 643.075 78.1584 648.858 78.1584C654.642 78.1584 659.437 80.1371 663.166 84.0184C666.895 87.9757 668.721 93.2269 668.721 99.7718C668.798 106.393 666.895 111.644 663.166 115.525Z",
    fill: "url(#paint2_linear_2566_7310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.227 68.2649C499.163 74.0488 502.131 82.7246 502.131 94.1401V135.54C502.131 137.367 500.609 138.889 498.782 138.889H482.801C480.974 138.889 479.452 137.367 479.452 135.54V97.6409C479.452 91.4765 478.082 86.8342 475.419 83.79C472.679 80.7459 468.798 79.2238 463.622 79.2238C457.915 79.2238 453.348 80.9742 450 84.5511C446.575 88.0518 444.901 93.3791 444.901 100.305V135.617C444.901 137.443 443.379 138.965 441.552 138.965H425.571C423.744 138.965 422.222 137.443 422.222 135.617V64.0031C422.222 62.1766 423.744 60.6546 425.571 60.6546H440.563C442.39 60.6546 443.912 62.1766 443.912 64.0031V69.787C446.88 66.5145 450.609 63.927 455.099 62.1766C459.589 60.3502 464.46 59.513 469.787 59.513C479.452 59.513 487.215 62.405 493.227 68.2649Z",
    fill: "url(#paint3_linear_2566_7310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.594 135.312C524.658 131.963 519.939 127.245 516.591 121.233C513.166 115.145 511.492 108.143 511.492 100.076C511.492 92.0092 513.166 85.0076 516.591 78.9193C520.015 72.8311 524.658 68.1888 530.594 64.8402C536.53 61.4916 543.151 59.8174 550.457 59.8174C560.426 59.8174 568.265 62.9376 573.973 69.2542V36.6819C573.973 32.5723 578.539 30.0609 582.04 32.1918C585.084 34.0944 589.117 36.8341 591.781 39.2694C595.282 42.3897 597.26 44.7489 597.26 47.4125C597.26 55.2512 597.032 117.352 596.956 134.323C596.956 136.91 594.825 138.965 592.238 138.965H579.528C576.941 138.965 574.81 136.834 574.81 134.247V130.137C569.178 136.91 561.035 140.335 550.228 140.335C543.227 140.259 536.606 138.584 530.594 135.312ZM540.107 84.2466C536.378 88.204 534.551 93.4551 534.551 100C534.551 106.621 536.454 111.872 540.107 115.753C543.836 119.711 548.63 121.613 554.414 121.613C560.198 121.613 564.992 119.635 568.722 115.753C572.451 111.796 574.277 106.545 574.277 100C574.277 93.379 572.375 88.1279 568.722 84.2466C564.992 80.2892 560.198 78.3866 554.414 78.3866C548.554 78.3866 543.836 80.3653 540.107 84.2466Z",
    fill: "url(#paint4_linear_2566_7310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.303 55.7839C598.63 51.9788 598.706 44.064 593.379 40.1066L582.116 31.8113C578.615 29.5282 573.973 32.0396 573.973 36.1492V69.5587L593.303 55.7839Z",
    fill: "url(#paint5_linear_2566_7310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.218 64.688C257.154 68.0366 261.872 72.755 265.221 78.7672C268.645 84.8554 270.32 91.857 270.32 99.9239C270.32 107.991 268.645 114.992 265.221 121.081C261.796 127.169 257.154 131.811 251.218 135.16C245.282 138.508 238.661 140.183 231.355 140.183C221.385 140.183 213.546 137.062 207.839 130.746V163.242C207.839 167.352 203.272 169.863 199.772 167.732C196.728 165.83 192.694 163.09 190.03 160.655C186.53 157.534 184.551 155.175 184.551 152.511C184.551 144.673 184.779 82.5723 184.855 65.6012C184.855 63.0137 186.986 60.9589 189.574 60.9589H202.283C204.871 60.9589 207.002 63.0898 207.002 65.6774V70.0153C212.633 63.242 220.776 59.8174 231.583 59.8174C238.661 59.7413 245.282 61.4156 251.218 64.688ZM241.781 115.753C245.51 111.796 247.336 106.545 247.336 100C247.336 93.379 245.434 88.1279 241.781 84.2466C238.052 80.2892 233.257 78.3866 227.473 78.3866C221.69 78.3866 216.895 80.3653 213.166 84.2466C209.437 88.204 207.61 93.4551 207.61 100C207.61 106.621 209.437 111.872 213.166 115.753C216.895 119.711 221.69 121.613 227.473 121.613C233.257 121.613 238.052 119.635 241.781 115.753Z",
    fill: "url(#paint6_linear_2566_7310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.584 144.216C183.257 148.021 183.181 155.936 188.508 159.893L199.772 168.189C203.272 170.472 207.915 167.96 207.915 163.851V130.441L188.584 144.216Z",
    fill: "url(#paint7_linear_2566_7310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75038 173.44C8.06697 179.756 20.1674 189.422 30.9741 196.423C42.4658 203.881 53.0441 199.087 53.8813 187.215C54.7945 174.505 54.7945 148.934 54.7945 148.934C54.7945 148.934 12.0244 161.568 9.58904 162.1C6.5449 162.785 4.18569 163.318 2.58752 164.84C1.14155 166.21 0 167.656 0 169.482C0 170.548 0 171.689 1.75038 173.44Z",
    fill: "url(#paint8_linear_2566_7310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.74 0.913156C102.74 0.913156 29.2237 22.6027 17.3516 26.3317C3.57683 30.5935 0.0760704 40.3348 0.0760704 49.9238C0.0760704 57.9908 0.0760704 65.1445 0.0760704 68.8736C0.0760704 72.6027 0.684899 82.7244 16.0578 79.8325C27.4733 77.7016 54.9467 69.3302 54.9467 69.3302C54.9467 69.3302 55.0989 60.0456 55.0989 56.5448C55.0989 51.8264 58.7519 50.9132 62.3287 52.6635C65.9056 54.4139 76.4079 60.1217 85.8447 65.1445C89.0411 66.8188 89.8782 71.0045 87.4429 73.6681C81.2024 80.5935 67.5799 97.0319 63.3942 101.674C59.7412 105.632 55.0989 103.501 55.0228 99.0867V87.8234C55.0228 87.8234 24.0487 96.9558 14.003 101.294C1.29373 106.849 0.0760704 115.373 0.0760704 119.482C0.0760704 119.482 -0.0761366 169.787 0.0760704 170.548C0.228277 169.635 0.380484 165.068 10.0456 162.176C18.4931 159.589 54.7945 148.858 54.7945 148.858L113.927 131.278C123.668 128.387 130.289 119.406 130.289 109.285V21.385C130.289 7.07754 116.514 -3.19643 102.74 0.913156Z",
    fill: "url(#paint9_linear_2566_7310)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.295 178.593C436.694 179.493 437.794 180.792 438.594 182.491C439.394 184.19 439.793 186.088 439.793 188.287C439.793 190.486 439.394 192.484 438.594 194.183C437.794 195.882 436.694 197.181 435.195 198.181C433.795 199.08 432.096 199.58 430.296 199.58C428.797 199.58 427.497 199.28 426.297 198.68C425.098 198.081 424.198 197.181 423.498 196.082V199.28H417V168.5H423.598V180.692C424.198 179.593 425.198 178.793 426.297 178.193C427.497 177.594 428.797 177.294 430.296 177.294C432.196 177.294 433.895 177.694 435.295 178.593ZM431.996 192.884C432.795 191.785 433.295 190.286 433.295 188.287C433.295 186.288 432.895 184.889 431.996 183.79C431.196 182.791 429.996 182.191 428.397 182.191C426.897 182.191 425.697 182.691 424.798 183.79C423.998 184.889 423.498 186.388 423.498 188.287C423.498 190.286 423.898 191.785 424.798 192.884C425.598 193.983 426.797 194.483 428.397 194.483C429.996 194.583 431.196 193.983 431.996 192.884Z",
    fill: "url(#paint10_linear_2566_7310)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M458.288 177.794H464.786L451.89 207.075H445.192L449.291 198.081L440.493 177.894H447.391L452.79 191.485L458.288 177.794Z",
    fill: "url(#paint11_linear_2566_7310)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M504.775 168.4H510.073V199.18H504.075V180.992L496.977 194.183H492.578L485.48 181.192V199.28H479.482V168.5H484.88L494.778 187.288L504.775 168.4Z",
    fill: "url(#paint12_linear_2566_7310)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M542.764 182.291V197.381C541.264 198.081 539.564 198.68 537.565 199.08C535.566 199.48 533.466 199.68 531.367 199.68C528.068 199.68 525.269 199.08 522.869 197.781C520.47 196.482 518.671 194.683 517.371 192.284C516.071 189.886 515.471 187.088 515.471 183.79C515.471 180.592 516.071 177.794 517.371 175.395C518.671 172.997 520.47 171.198 522.769 169.899C525.169 168.6 527.868 168 531.067 168C533.266 168 535.366 168.3 537.265 168.899C539.165 169.499 540.764 170.398 541.964 171.398L539.864 176.295C538.465 175.295 537.065 174.496 535.666 174.096C534.266 173.596 532.866 173.397 531.267 173.397C525.369 173.397 522.369 176.894 522.369 183.79C522.369 187.388 523.169 189.986 524.669 191.785C526.168 193.484 528.568 194.383 531.667 194.383C533.366 194.383 535.066 194.183 536.665 193.683V186.988H530.667V182.291H542.764Z",
    fill: "url(#paint13_linear_2566_7310)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M587.151 182.291V197.381C585.651 198.081 583.952 198.68 581.952 199.08C579.953 199.48 577.853 199.68 575.754 199.68C572.455 199.68 569.656 199.08 567.257 197.781C564.857 196.482 563.058 194.683 561.758 192.284C560.458 189.886 559.859 187.088 559.859 183.79C559.859 180.592 560.458 177.794 561.758 175.395C563.058 172.997 564.857 171.198 567.157 169.899C569.556 168.6 572.255 168 575.454 168C577.653 168 579.753 168.3 581.652 168.899C583.552 169.499 585.151 170.398 586.351 171.398L584.252 176.295C582.852 175.295 581.452 174.496 580.053 174.096C578.653 173.596 577.254 173.397 575.654 173.397C569.756 173.397 566.757 176.894 566.757 183.79C566.757 187.388 567.556 189.986 569.056 191.785C570.556 193.484 572.955 194.383 576.054 194.383C577.753 194.383 579.453 194.183 581.053 193.683V186.988H575.054V182.291H587.151Z",
    fill: "url(#paint14_linear_2566_7310)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M607.745 182.691L604.046 183.09C602.246 183.29 600.947 183.79 600.147 184.689C599.347 185.589 599.047 186.688 599.047 188.087V199.28H592.449V177.794H598.747V181.391C599.847 178.893 602.046 177.594 605.445 177.294L607.345 177.194L607.745 182.691Z",
    fill: "url(#paint15_linear_2566_7310)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M613.843 198.181C612.144 197.281 610.844 195.982 609.844 194.283C608.944 192.584 608.445 190.685 608.445 188.387C608.445 186.088 608.944 184.19 609.844 182.491C610.744 180.792 612.144 179.493 613.843 178.593C615.543 177.694 617.542 177.194 619.841 177.194C622.141 177.194 624.14 177.694 625.84 178.593C627.539 179.493 628.839 180.792 629.838 182.491C630.738 184.19 631.238 186.088 631.238 188.387C631.238 190.685 630.738 192.584 629.838 194.283C628.939 195.982 627.539 197.281 625.84 198.181C624.14 199.08 622.141 199.58 619.841 199.58C617.542 199.58 615.543 199.08 613.843 198.181ZM624.64 188.387C624.64 186.288 624.24 184.789 623.44 183.79C622.64 182.791 621.441 182.291 619.841 182.291C616.642 182.291 615.043 184.389 615.043 188.487C615.043 192.584 616.642 194.683 619.841 194.683C623.04 194.583 624.64 192.484 624.64 188.387Z",
    fill: "url(#paint16_linear_2566_7310)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M655.831 177.794V199.28H649.433V196.182C648.733 197.281 647.833 198.181 646.833 198.68C645.734 199.28 644.534 199.58 643.135 199.58C640.435 199.58 638.436 198.78 637.036 197.281C635.737 195.782 635.037 193.484 635.037 190.486V177.694H641.635V190.586C641.635 191.885 641.935 192.784 642.435 193.384C642.935 193.983 643.834 194.283 644.934 194.283C646.234 194.283 647.233 193.883 648.033 192.984C648.833 192.085 649.233 190.985 649.233 189.486V177.594H655.831V177.794Z",
    fill: "url(#paint17_linear_2566_7310)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M679.124 178.693C680.524 179.593 681.724 180.992 682.523 182.691C683.323 184.389 683.723 186.388 683.723 188.587C683.723 190.785 683.323 192.784 682.523 194.383C681.724 196.082 680.624 197.381 679.224 198.281C677.825 199.18 676.125 199.68 674.326 199.68C672.826 199.68 671.527 199.38 670.327 198.78C669.127 198.181 668.227 197.381 667.628 196.282V207.175H661.03V177.894H667.528V180.892C668.127 179.792 669.127 178.893 670.327 178.293C671.527 177.694 672.826 177.394 674.326 177.394C676.025 177.294 677.725 177.694 679.124 178.693ZM675.825 192.984C676.625 191.985 677.125 190.486 677.125 188.487C677.125 186.488 676.725 184.989 675.825 183.89C675.026 182.79 673.826 182.291 672.226 182.291C670.727 182.291 669.527 182.79 668.627 183.89C667.828 184.989 667.328 186.488 667.328 188.487C667.328 190.486 667.728 191.985 668.627 192.984C669.427 194.083 670.627 194.583 672.226 194.583C673.826 194.583 675.026 194.083 675.825 192.984Z",
    fill: "url(#paint18_linear_2566_7310)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2566_7310",
    x1: 304.402,
    y1: 181.198,
    x2: 304.402,
    y2: 50.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2566_7310",
    x1: 371.815,
    y1: 181.198,
    x2: 371.815,
    y2: 50.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2566_7310",
    x1: 648.799,
    y1: 181.198,
    x2: 648.799,
    y2: 50.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2566_7310",
    x1: 462.182,
    y1: 181.198,
    x2: 462.182,
    y2: 50.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2566_7310",
    x1: 554.425,
    y1: 181.198,
    x2: 554.425,
    y2: 50.8499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2566_7310",
    x1: 587.251,
    y1: 58.8822,
    x2: 568.313,
    y2: 36.0795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#540DCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2566_7310",
    x1: 227.45,
    y1: 181.198,
    x2: 227.45,
    y2: 50.8499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2566_7310",
    x1: 196.111,
    y1: 143.008,
    x2: 212.567,
    y2: 161.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#540DCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2566_7310",
    x1: 22.9514,
    y1: 146.371,
    x2: 40.29,
    y2: 198.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#3772F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    stopColor: "#2694F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#18AFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5109,
    stopColor: "#0DC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#06D4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7789,
    stopColor: "#01DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2566_7310",
    x1: -13.2394,
    y1: 157.261,
    x2: 130.881,
    y2: 13.1413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2566_7310",
    x1: 413.421,
    y1: 204.717,
    x2: 446.453,
    y2: 196.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2566_7310",
    x1: 436.679,
    y1: 211.914,
    x2: 471.381,
    y2: 202.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2566_7310",
    x1: 474.678,
    y1: 204.384,
    x2: 517.196,
    y2: 190.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2566_7310",
    x1: 511.186,
    y1: 204.916,
    x2: 549.975,
    y2: 194.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2566_7310",
    x1: 555.573,
    y1: 204.916,
    x2: 594.362,
    y2: 194.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2566_7310",
    x1: 590.047,
    y1: 202.93,
    x2: 612.339,
    y2: 198.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2566_7310",
    x1: 604.865,
    y1: 203.28,
    x2: 636.384,
    y2: 193.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2566_7310",
    x1: 631.772,
    y1: 203.214,
    x2: 660.906,
    y2: 194.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2566_7310",
    x1: 657.466,
    y1: 212.099,
    x2: 690.22,
    y2: 204.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C3DF7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2566_7310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 691.705,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrendoByMgGroup);
export default __webpack_public_path__ + "static/media/logo-prendo-by-mg-group.cf884c37e0f8339b143869b5c1730b74.svg";
export { ForwardRef as ReactComponent };